import {
  ClockConfig,
  CustomHomepageGrid,
  HeaderWorldClock,
  HomePageStarredEntities,
  WelcomeTitle,
  HomePageRandomJoke,
  HomePageTopVisited,
  HomePageRecentlyVisited} from '@backstage/plugin-home';
import { Content, Header, Page } from '@backstage/core-components';
import React from 'react';

const clockConfigs: ClockConfig[] = [
  {
    label: 'Japan',
    timeZone: 'Asia/Tokyo',
  },
  {
    label: 'India',
    timeZone: 'Asia/Kolkata',
  },
  {
    label: 'Germany',
    timeZone: 'Europe/Berlin',
  },
  {
    label: 'US-Detroit',
    timeZone: 'America/Detroit',
  },
  {
    label: 'US-Portland',
    timeZone: 'America/Los_Angeles',
  },
];

const timeFormat: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
};

const defaultConfig = [
  {
    component: 'HomePageTopVisited',
    x: 0,
    y: 1,
    width: 5,
    height: 5,
  },
  {
    component: 'HomePageRecentlyVisited',
    x: 6,
    y: 1,
    width: 5,
    height: 5,
  },
  {
    component: 'HomePageStarredEntities',
    x: 0,
    y: 0,
    width: 5,
    height: 5,
  },
  {
    component: 'HomePageRandomJoke',
    x: 6,
    y: 0,
    width: 5,
    height: 5,
  }
];

const languages = ['English'];

export const HomePage = (
  <Page themeId="home">
    <Header title={<WelcomeTitle language={languages}/>} pageTitleOverride="Home">
      <HeaderWorldClock
        clockConfigs={clockConfigs}
        customTimeFormat={timeFormat}
      />
    </Header>
    <Content>
      <CustomHomepageGrid config={defaultConfig}>
        <HomePageTopVisited title="Top visited" />
        <HomePageRecentlyVisited title="Recently visited" />
        <HomePageStarredEntities title="Your starred artifacts" />
        <HomePageRandomJoke title="Thought of the day!" />
      </CustomHomepageGrid>
    </Content>
  </Page>
);